import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';

import Tab from '../../../components/Tab';

const messages = defineMessages({
  fraternaties: {
    id: 'hubs.organizations-and-services.greek-life.fraternaties',
    defaultMessage: 'Number of Fraternities',
  },
  sororities: {
    id: 'hubs.organizations-and-services.greek-life.sororities',
    defaultMessage: 'Number of Sororities',
  },
});

function GreekLife({ intl, greekLife }) {
  const fraternaties = get(greekLife, 'fraternaties.value', false);
  const sororities = get(greekLife, 'sororities.value', false);

  return (
    <Tab.Pane>
      {fraternaties ? (
        <p>
          <b>{intl.formatMessage(messages.fraternaties)}:</b> {fraternaties}
        </p>
      ) : null}
      {sororities ? (
        <p>
          <b>{intl.formatMessage(messages.sororities)}:</b> {sororities}
        </p>
      ) : null}
    </Tab.Pane>
  );
}

GreekLife.propTypes = {
  greekLife: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(GreekLife);
